var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", staticStyle: { width: "fit-content" } },
    [
      _c(
        "div",
        { staticClass: "section" },
        [
          _c(
            "el-form",
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "booking", disabled: _vm.readonly },
                  model: {
                    value: _vm.form.booking,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "booking", $$v)
                    },
                    expression: "form.booking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "customs", disabled: _vm.readonly },
                  on: {
                    change: function(val) {
                      _vm.form.customsBroker = val ? _vm.form.customsBroker : 0
                      _vm.form.customsDeclarationType = val
                        ? _vm.form.customsDeclarationType
                        : -1
                    }
                  },
                  model: {
                    value: _vm.form.customs,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "customs", $$v)
                    },
                    expression: "form.customs"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { disabled: _vm.readonly, no: "isInsure" },
                  model: {
                    value: _vm.form.insure,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "insure", $$v)
                    },
                    expression: "form.insure"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
              ),
              _vm.isBookingNew && _vm.isFba
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { no: "destinationPortService" },
                      model: {
                        value: _vm.form.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destinationPortService", $$v)
                        },
                        expression: "form.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e(),
              _vm.viewSource === "bookingWorkspace"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_insurance_toInsure"],
                          expression: "['button_insurance_toInsure']"
                        }
                      ],
                      staticStyle: { "margin-left": "20px" },
                      attrs: {
                        no: "Insure",
                        disabled: _vm.isEdit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.pm.toInsure()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
                  )
                : _vm._e(),
              !_vm.isFba
                ? _c("span", { staticStyle: { "margin-left": "20px" } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))
                  ])
                : _vm._e(),
              !_vm.isFba
                ? _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { no: "lob", disabled: _vm.readonly },
                      on: { change: _vm.lobChangeHandler },
                      model: {
                        value: _vm.form.lob,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "lob", $$v)
                        },
                        expression: "form.lob"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { no: "RE", label: "RE" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))
                      ]),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-left": "-20px" },
                          attrs: { no: "RI", label: "RI" }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !!_vm.templateName
                ? _c(
                    "span",
                    {
                      staticClass: "blue",
                      staticStyle: {
                        float: "right",
                        "margin-right": "30px",
                        "line-height": "28px",
                        padding: "0 5px",
                        "white-space": "nowrap"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_SopTemplate")) +
                          ": " +
                          _vm._s(_vm.templateName)
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "tab-booking-master-UICustom-layout",
        {
          attrs: { "element-blocks": _vm.elementBlocks, disabled: _vm.readonly }
        },
        [
          _vm.elementDict.jobNo.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "jobNo" }, slot: "jobNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.jobNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      value: _vm.form.jobNo,
                      no: "jobNo",
                      disabled: true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isZY
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: { slot: "saleProductCode" },
                    slot: "saleProductCode"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AllowSaleProduct")))]
                    ),
                    _c("cargo-advance-select", {
                      attrs: {
                        "select-type":
                          _vm.selectTypeNames.basic_data_AllowSaleProduct,
                        filterable: "",
                        no: "allowSaleProduct",
                        clearable: "",
                        "data-filter-function": function(p) {
                          if (!p.statusEnabled) {
                            return false
                          }
                          return _vm.isFba ? p.fbaRailway : p.railwayFreight
                        },
                        "default-value": _vm.form.saleProductCode || ""
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.saleProductCode = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { slot: "fullOrInside" }, slot: "fullOrInside" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                    ),
                    _c("cargo-advance-select", {
                      attrs: {
                        "select-type":
                          _vm.selectTypeNames
                            .local_cache_FullOrInside$FULL_OR_INSIDE,
                        no: "fullOrInside",
                        clearable: "",
                        "default-value": _vm.form.fullOrInside || ""
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.form.fullOrInside = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm.elementDict.containerLoadType.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "containerLoadType" },
                  slot: "containerLoadType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.containerLoadType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.containerLoadType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: { no: "containerLoadType" },
                      on: {
                        change: function($event) {
                          _vm.pm.selectDefaultCutomJobType()
                          _vm.onContainerLoadTypeChange()
                        }
                      },
                      model: {
                        value: _vm.form.containerLoadType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "containerLoadType", $$v)
                        },
                        expression: "form.containerLoadType"
                      }
                    },
                    _vm._l(_vm.containerLoadTypes, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.chineseName, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoType.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoType" }, slot: "cargoType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "cargoType",
                      "select-type": _vm.selectTypeNames.basic_data_CargoType,
                      headers: [_vm.$t("Partners.chineseName")],
                      fields: ["chineseName"],
                      "filter-field-names": ["chineseName"],
                      "method-params": { sea: true },
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.cargoType
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.cargoType = p.value
                        _vm.onCargoTypeChagne()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transportType.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportType" }, slot: "transportType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transportType",
                      "select-type":
                        _vm.selectTypeNames.basic_data_TransportationType,
                      "method-params": {
                        companyLob: "railwayExport",
                        transportType: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.transportType,
                      "tag-name":
                        this.$store.getters.language === "zh"
                          ? "chineseName"
                          : "englishName",
                      "tag-value": "code",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.transportType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.fullHalf.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "fullHalf" }, slot: "fullHalf" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.fullHalf.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.fullHalf.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "fullHalf",
                      "select-type": _vm.selectTypeNames.local_cache_FullHalf,
                      filterable: "",
                      "default-value": _vm.form.fullHalf
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.fullHalf = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transportLine.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportLine" }, slot: "transportLine" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportLine.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportLine.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transportLine",
                      "select-type": _vm.selectTypeNames.basic_data_RailwayLine,
                      filterable: "",
                      "default-value": _vm.form.transportLine,
                      "tag-name": "name"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.transportLine = p.value
                        _vm.pm.refreshPlanner(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.etd.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "etd" }, slot: "etd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.etd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.etd.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "departure-date-picker",
                        staticStyle: {
                          flex: "1",
                          width: "140px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          no: "etd",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.etdChange },
                        model: {
                          value: _vm.form.etd,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "etd", $$v)
                          },
                          expression: "form.etd"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.sailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.eta.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "eta" }, slot: "eta" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.eta.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.eta.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: {
                          flex: "1",
                          width: "140px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          no: "eta",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { input: _vm.etaChange },
                        model: {
                          value: _vm.form.eta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "eta", $$v)
                          },
                          expression: "form.eta"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.etaSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.atd.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "atd" }, slot: "atd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.atd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.atd.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: {
                          flex: "1",
                          width: "140px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          no: "atd",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        on: { input: _vm.atdChange },
                        model: {
                          value: _vm.form.atd,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "atd", $$v)
                          },
                          expression: "form.atd"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.atdSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.ata.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "ata" }, slot: "ata" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.ata.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.ata.label },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: {
                          flex: "1",
                          width: "140px",
                          "margin-right": "5px"
                        },
                        attrs: {
                          no: "ata",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        on: { input: _vm.ataChange },
                        model: {
                          value: _vm.form.ata,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ata", $$v)
                          },
                          expression: "form.ata"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("filterWeek")(_vm.form.ataSailingDay))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "customsDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.form.customsDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "customsDate", $$v)
                      },
                      expression: "form.customsDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.departureStation.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "departureStation" },
                  slot: "departureStation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.departureStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.departureStation.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "departureStation",
                          "select-type":
                            _vm.selectTypeNames.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.form.departureStation
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.departureStation = p.value
                            _vm.onDepartureStationChange()
                          }
                        }
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { width: "80px", "padding-left": "5px" },
                          attrs: { no: "transfer" },
                          model: {
                            value: _vm.form.transfer,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "transfer", $$v)
                            },
                            expression: "form.transfer"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.form.transfer &&
                    _vm.elementDict.transferStation.masterVisible,
                  expression:
                    "form.transfer && elementDict.transferStation.masterVisible"
                }
              ],
              attrs: { slot: "transferStation" },
              slot: "transferStation"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.transferStation.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.transferStation.label
                },
                slot: "label"
              }),
              _c("cargo-advance-select", {
                attrs: {
                  no: "transferStation",
                  "select-type": _vm.selectTypeNames.basic_data_RailwayStation,
                  filterable: "",
                  "default-value": _vm.form.transferStation
                },
                on: {
                  parentCallBack: function(p) {
                    _vm.form.transferStation = p.value
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.transitStation.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transitStation" }, slot: "transitStation" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transitStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transitStation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "transitStation",
                      "select-type":
                        _vm.selectTypeNames.basic_data_RailwayStation,
                      filterable: "",
                      "default-value": _vm.form.transitStation
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.transitStation = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationStation.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationStation" },
                  slot: "destinationStation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationStation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationStation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "destinationStation",
                      "select-type":
                        _vm.selectTypeNames.basic_data_RailwayStation,
                      filterable: "",
                      "default-value": _vm.form.destinationStation
                    },
                    on: { parentCallBack: _vm.destinationStationChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationCountry.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationCountry" },
                  slot: "destinationCountry"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationCountry.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationCountry.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "destinationCountry",
                      "select-type": _vm.selectTypeNames.basic_data_Country,
                      filterable: "",
                      "default-value": _vm.form.destinationCountry
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.destinationCountry = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSource.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSource.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSource.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "cargoSource",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        clearable: false,
                        size: "mini"
                      },
                      on: {
                        change: function($event) {
                          _vm.form.designationAgent = 0
                          _vm.pm.cargoSourceChange()
                        }
                      },
                      model: {
                        value: _vm.form.cargoSource,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cargoSource", $$v)
                        },
                        expression: "form.cargoSource"
                      }
                    },
                    _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.chineseName, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customJobType.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customJobType" }, slot: "customJobType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customJobType.label
                    },
                    slot: "label"
                  }),
                  _vm.form.lob === "RE"
                    ? _c("cargo-advance-select", {
                        key: "1",
                        ref: "customJobType",
                        attrs: {
                          no: "customJobType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "static-options": _vm.customJobTypeList,
                          "method-params": { type: _vm.form.lob },
                          "default-value": _vm.form.customJobType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customJobType = p.value
                            _vm.onCustomJobTypeChange()
                          }
                        }
                      })
                    : _vm.form.lob === "RI"
                    ? _c("cargo-advance-select", {
                        key: "2",
                        ref: "customJobType",
                        attrs: {
                          no: "customJobType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "method-params": { type: _vm.form.lob },
                          "static-options": _vm.customJobTypeList,
                          "default-value": _vm.form.customJobType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customJobType = p.value
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.form.customJobType &&
          _vm.secondaryCustomJobTypeList.length > 0 &&
          _vm.elementDict.secondaryCustomJobType.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "secondaryCustomJobType" },
                  slot: "secondaryCustomJobType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.secondaryCustomJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.secondaryCustomJobType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "secondaryCustomJobType",
                    attrs: {
                      no: "secondaryCustomJobType",
                      "select-type":
                        _vm.selectTypeNames.basic_data_CutomJobType,
                      filterable: "",
                      cache: false,
                      "default-value": _vm.form.secondaryCustomJobType,
                      "tag-name": _vm.isZh ? "name" : "englishName",
                      "static-options": _vm.secondaryCustomJobTypeList
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.secondaryCustomJobType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingAgent.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingAgent.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "bookingAgent",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": {
                        companyLob: "railwayExport",
                        bookingAgent: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.bookingAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.bookingAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.portAgent.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "portAgent" }, slot: "portAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.portAgent.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.portAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "portAgent",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": {
                        companyLob: "railwayExport",
                        portAgent: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.portAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.portAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.forwardingAgent.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "forwardingAgent" }, slot: "forwardingAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.forwardingAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.forwardingAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "forwardingAgent",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": {
                        companyLob: "railwayExport",
                        forwardingAgent: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.forwardingAgent || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.forwardingAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationAgent.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationAgent" },
                  slot: "destinationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationAgent.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.destinationAgentTip,
                        disabled: !_vm.showDestinationAgentWarning,
                        placement: "right-end"
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        ref: "destinationAgent",
                        attrs: {
                          no: "destinationAgent",
                          "method-params": {
                            overseaAgent: true,
                            active: true,
                            companyLob: "railwayExport"
                          },
                          "check-credit": true,
                          job: _vm.form,
                          "default-value": _vm.form.destinationAgent || "",
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName"
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.txtDestinationAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.form.cargoSource === "NC" &&
                    _vm.elementDict.designationAgent.masterVisible,
                  expression:
                    "form.cargoSource==='NC' && elementDict.designationAgent.masterVisible"
                }
              ],
              attrs: { slot: "designationAgent" },
              slot: "designationAgent"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.designationAgent.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.designationAgent.label
                },
                slot: "label"
              }),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.designationAgentTip,
                    disabled: !_vm.showDesignationAgentWarning,
                    placement: "right-end"
                  }
                },
                [
                  _c("cargo-company-select", {
                    staticClass: "designation-agent-selector",
                    staticStyle: { width: "190px" },
                    attrs: {
                      no: "designationAgent",
                      "popper-class": "designation-agent-selector-popper",
                      disabled: !_vm.designationAgentEnabled,
                      "method-params": { designationAgent: true, active: true },
                      "check-credit": true,
                      job: _vm.form,
                      "default-value": _vm.form.designationAgent || "",
                      filterable: "",
                      headers: [_vm.$t("Partners.englishName")],
                      fields: ["englishName"],
                      "tag-name": "englishName"
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.txtDesignationAgentChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.elementDict.transportSource.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "transportSource" }, slot: "transportSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transportSource.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transportSource.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      filterable: "",
                      "select-type":
                        _vm.selectTypeNames.basic_data_TransportSource,
                      no: "transportSource",
                      "default-value": _vm.form.transportSource,
                      cache: false,
                      "tag-value": "code",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.transportSource = item.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.statisticArea.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "statisticArea" }, slot: "statisticArea" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.statisticArea.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.statisticArea.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      filterable: "",
                      "select-type":
                        _vm.selectTypeNames.basic_data_StatisticArea,
                      no: "statisticArea",
                      "default-value": _vm.form.statisticArea,
                      cache: false,
                      "tag-value": "code",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.statisticArea = item.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.localService.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "localService" }, slot: "localService" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.localService.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.localService.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "warehousing" },
                      on: {
                        change: function($event) {
                          return _vm.pm.loadingTermChange("warehousing")
                        }
                      },
                      model: {
                        value: _vm.form.warehousing,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "warehousing", $$v)
                        },
                        expression: "form.warehousing"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.WarehouseLoadingStorage"))
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "landTransportation" },
                      on: {
                        change: function($event) {
                          return _vm.pm.loadingTermChange("landTransportation")
                        }
                      },
                      model: {
                        value: _vm.form.landTransportation,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "landTransportation", $$v)
                        },
                        expression: "form.landTransportation"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.DoorLoadingDelivery")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "selfDeliver" },
                      model: {
                        value: _vm.form.selfDeliver,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "selfDeliver", $$v)
                        },
                        expression: "form.selfDeliver"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "SeaExport.NotResponsibleForTruckingAndLoading"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentMethod.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentMethod" }, slot: "paymentMethod" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentMethod.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentMethod.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "paymentMethod",
                      "select-type":
                        _vm.selectTypeNames.basic_data_PaymentMethod,
                      "method-params": {
                        companyLob: "railwayExport",
                        paymentMethod: true,
                        active: true
                      },
                      filterable: "",
                      "default-value": _vm.form.paymentMethod,
                      "tag-name":
                        this.$store.getters.language === "zh"
                          ? "chineseName"
                          : "englishName",
                      "tag-value": "code",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.paymentMethod = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mbl.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "mbl" }, slot: "mbl" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mbl.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.mbl.label },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "mbl" },
                    model: {
                      value: _vm.form.mbl,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "mbl", $$v)
                      },
                      expression: "form.mbl"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.vessel.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "vessel" }, slot: "vessel" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.vessel.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.vessel.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "vessel" },
                    model: {
                      value: _vm.form.vessel,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "vessel", $$v)
                      },
                      expression: "form.vessel"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.voyageFlight.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "voyageFlight" }, slot: "voyageFlight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.voyageFlight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.voyageFlight.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "voyageFlight" },
                    model: {
                      value: _vm.form.voyageFlight,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "voyageFlight", $$v)
                      },
                      expression: "form.voyageFlight"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerRefNo.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerRefNo" }, slot: "customerRefNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerRefNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerRefNo.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-input", {
                    attrs: { no: "customerRefNo", trim: true },
                    model: {
                      value: _vm.form.customerRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "customerRefNo", $$v)
                      },
                      expression: "form.customerRefNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.poNo.masterVisible
            ? _c(
                "el-form-item",
                {
                  class: _vm.poNoRed ? "poNoClass" : "",
                  attrs: { slot: "poNo" },
                  slot: "poNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.poNo.label },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "poNo" },
                    model: {
                      value: _vm.form.poNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "poNo", $$v)
                      },
                      expression: "form.poNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsBroker.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsBroker" }, slot: "customsBroker" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsBroker.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsBroker.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsBroker",
                      disabled: !_vm.customsBrokerEnabled,
                      "method-params": { customsBroker: true },
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "data-filter-function": _vm.customsBrokerFilter,
                      filterable: "",
                      "default-value": _vm.form.customsBroker || "",
                      placeholder: _vm.form.customs
                        ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        : _vm.$t("SeaExport.PleaseTickCustomsDeclarationOption")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.pm.customsBrokerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customClaim.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customClaim" }, slot: "customClaim" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customClaim.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customClaim.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsMethod",
                      disabled: !_vm.customsBrokerEnabled,
                      "select-type": _vm.selectTypeNames.basic_data_CustomsMode,
                      "method-params": { serviceType: 2 },
                      "tag-value": "serialNum",
                      filterable: "",
                      "default-value": _vm.form.customClaim
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.customClaim = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDeclarationType.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "customsDeclarationType" },
                  slot: "customsDeclarationType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDeclarationType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDeclarationType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsDeclarationType",
                      disabled: !_vm.customsBrokerEnabled,
                      "select-type":
                        _vm.selectTypeNames.basic_data_CustomsDeclarationType,
                      filterable: "",
                      "default-value":
                        _vm.form.customsDeclarationType === -1
                          ? ""
                          : _vm.form.customsDeclarationType,
                      placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.customsDeclarationType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.tradeTerm.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.tradeTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.tradeTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "tradeTerm",
                      filterable: "",
                      "select-type": _vm.selectTypeNames.basic_data_TradeTerm,
                      "callback-method-type": "value",
                      "default-value": _vm.form.tradeTerm,
                      "callback-params": { key: "tradeTerm" }
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.tradeTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.incoTerm.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.incoTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "incoTerm",
                      filterable: "",
                      clearable: false,
                      "select-type": _vm.selectTypeNames.basic_data_IncoTerm,
                      "callback-method-type": "value",
                      "default-value": _vm.form.incoTerm,
                      "callback-params": { key: "incoTerm" },
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.incoTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.carryingCmp.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "carryingCmp" }, slot: "carryingCmp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carryingCmp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carryingCmp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      no: "carryingCmp",
                      disabled: !_vm.form.landTransportation,
                      "method-params": { truckCmp: true, active: true },
                      "default-value": _vm.form.carryingCmp || "",
                      placeholder: _vm.form.landTransportation
                        ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        : _vm.$t(
                            "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                          )
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.carryingCmpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freightTerm.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "freightTerm" }, slot: "freightTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freightTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freightTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "freightTerm",
                      "select-type":
                        _vm.selectTypeNames.basic_data_ShippingTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.freightTerm
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.freightTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseCmp.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseCmp" }, slot: "warehouseCmp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseCmp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseCmp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      no: "warehouseCmp",
                      disabled: !_vm.warehouseEabled,
                      "method-params": { warehouse: true, active: true },
                      "default-value": _vm.form.warehouseCmp || "",
                      placeholder: _vm.form.warehousing
                        ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        : _vm.$t("SeaExport.PleaseSelectWarehouse")
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.warehouseCmpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.openWarehouse && _vm.elementDict.warehouseName.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseName" }, slot: "warehouseName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseName.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseName.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      ref: "warehouseName",
                      attrs: {
                        no: "warehouseName",
                        disabled:
                          !_vm.warehouseEabled || !_vm.form.warehouseCmp,
                        "allow-create": true,
                        filterable: "",
                        clearable: true
                      },
                      on: { change: _vm.warehouseNameChangeHandler },
                      model: {
                        value: _vm.form.warehouseName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "warehouseName", $$v)
                        },
                        expression: "form.warehouseName"
                      }
                    },
                    _vm._l(_vm.warehouseNameList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.warehouseName,
                          value: item.warehouseName
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.diffPlacesCollaborate.slaveVisible
            ? _c(
                "template",
                { slot: "diffPlacesCollaborate" },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { no: "diffPlacesCollaborate" },
                      model: {
                        value: _vm.form.diffPlacesCollaborate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "diffPlacesCollaborate", $$v)
                        },
                        expression: "form.diffPlacesCollaborate"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("RailwayExport.isDiffPlacesCollaborate"))
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.loadingPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "loadingPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            loadingPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.loadingPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.loadingPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.signBillPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "signBillPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            signBillPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.signBillPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.signBillPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.fullShipment.slaveVisible
            ? _c(
                "template",
                { slot: "fullShipment" },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.form.fullShipment,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fullShipment", $$v)
                        },
                        expression: "form.fullShipment"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("RailwayExport.isFullShipment")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.dischargePortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "dischargePortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            dischargePortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.dischargePortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dischargePortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationPortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "destinationPortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            destinationPortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.form,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.form.destinationPortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.destinationPortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.seaEq.slaveVisible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "seaEq", "label-width": "0" },
                  slot: "seaEq"
                },
                [
                  _c("booking-sea-eq-data-grid", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      value: _vm.seaEqList,
                      "container-load-type": _vm.form.containerLoadType,
                      "hide-soc": true,
                      "is-edit": _vm.isEdit,
                      job: _vm.form
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.quantityConsignActual.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "quantityConsignActual" },
                  slot: "quantityConsignActual"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quantityConsignActual.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quantityConsignActual.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "quantityContract", precision: 0, min: 0 },
                        on: {
                          change: function($event) {
                            _vm.SEUtils.changeQWCRule(function() {
                              _vm.form.quantityActual =
                                _vm.form.quantityContract
                            })
                          }
                        },
                        model: {
                          value: _vm.form.quantityContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quantityContract", $$v)
                          },
                          expression: "form.quantityContract"
                        }
                      }),
                      _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/")
                      ]),
                      _c("auto-number-input", {
                        attrs: { no: "quantityActual", precision: 0, min: 0 },
                        on: {
                          change: function($event) {
                            _vm.SEUtils.changeQWCRule(null, function() {
                              _vm.form.quantityContract =
                                _vm.form.quantityActual
                            })
                          }
                        },
                        model: {
                          value: _vm.form.quantityActual,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "quantityActual", $$v)
                          },
                          expression: "form.quantityActual"
                        }
                      }),
                      _c("span", [_vm._v("PCS")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.weightConsignActual.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "weightConsignActual" },
                  slot: "weightConsignActual"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.weightConsignActual.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.weightConsignActual.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        attrs: { no: "weightContract", precision: 3, min: 0 },
                        on: { change: _vm.weightContractChange },
                        model: {
                          value: _vm.form.weightContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "weightContract", $$v)
                          },
                          expression: "form.weightContract"
                        }
                      }),
                      _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/")
                      ]),
                      _c("auto-number-input", {
                        attrs: { no: "weightActual", precision: 3, min: 0 },
                        on: { change: _vm.weightActualChange },
                        model: {
                          value: _vm.form.weightActual,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "weightActual", $$v)
                          },
                          expression: "form.weightActual"
                        }
                      }),
                      _c("span", [_vm._v("KGS")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cubageConsignActual.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cubageConsignActual" },
                  slot: "cubageConsignActual"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cubageConsignActual.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cubageConsignActual.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("auto-number-input", {
                        attrs: {
                          no: "cubageContract",
                          precision: 3,
                          disabled: !_vm.cubageActualEnabled,
                          min: 0
                        },
                        on: { change: _vm.cubageContractChange },
                        model: {
                          value: _vm.form.cubageContract,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cubageContract", $$v)
                          },
                          expression: "form.cubageContract"
                        }
                      }),
                      _c("span", { staticStyle: { padding: "0 2px" } }, [
                        _vm._v("/")
                      ]),
                      _c("auto-number-input", {
                        ref: "cubageActual",
                        attrs: { no: "cubageActual", precision: 3, min: 0 },
                        on: { change: _vm.cubageActualChange },
                        model: {
                          value: _vm.form.cubageActual,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cubageActual", $$v)
                          },
                          expression: "form.cubageActual"
                        }
                      }),
                      _c("span", [_vm._v("CBM")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.packing.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "packing" }, slot: "packing" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.packing.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.packing.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    ref: "packing",
                    staticStyle: { width: "100%" },
                    attrs: { no: "packing", "default-value": _vm.form.packing },
                    on: {
                      change: function(p) {
                        _vm.form.packing = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoChineseName.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoChineseName" },
                  slot: "cargoChineseName"
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c(
                        "span",
                        {
                          class: _vm.elementDict.cargoChineseName.isRequire
                            ? "blue"
                            : ""
                        },
                        [_vm._v(_vm._s(_vm.elementDict.cargoChineseName.label))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          attrs: { no: "MergingTickets", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.pm.mergeLclCargoDocInfo(
                                "cargoChineseName",
                                _vm.form
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                      )
                    ],
                    1
                  ),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "70px", "min-height": "70px" },
                    attrs: {
                      "show-count": true,
                      no: "cargoChineseName",
                      disabled: _vm.readonly,
                      "auto-half-word": false,
                      "text-chars": 0
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                          _vm.form.cargoChineseName,
                          true,
                          function(val) {
                            _vm.form.cargoChineseName = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.cargoChineseName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cargoChineseName", $$v)
                      },
                      expression: "form.cargoChineseName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoEnglishName.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoEnglishName" },
                  slot: "cargoEnglishName"
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c(
                        "span",
                        {
                          class: _vm.elementDict.cargoEnglishName.isRequire
                            ? "blue"
                            : ""
                        },
                        [_vm._v(_vm._s(_vm.elementDict.cargoEnglishName.label))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          attrs: { no: "MergingTickets2", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.pm.mergeLclCargoDocInfo(
                                "cargoEnglishName",
                                _vm.form
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                      )
                    ],
                    1
                  ),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "70px", "min-height": "70px" },
                    attrs: {
                      "show-count": true,
                      no: "cargoEnglishName",
                      disabled: _vm.readonly,
                      "text-chars": 0,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                          _vm.form.cargoEnglishName,
                          _vm.isUppercaseByConfig,
                          function(val) {
                            _vm.form.cargoEnglishName = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.cargoEnglishName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cargoEnglishName", $$v)
                      },
                      expression: "form.cargoEnglishName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mark.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "mark" }, slot: "mark" },
                [
                  _c(
                    "div",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c(
                        "span",
                        { class: _vm.elementDict.mark.isRequire ? "blue" : "" },
                        [_vm._v(_vm._s(_vm.elementDict.mark.label))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          attrs: { no: "MergingTickets3", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.pm.mergeLclCargoDocInfo(
                                "mark",
                                _vm.form
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.MergingTickets")))]
                      )
                    ],
                    1
                  ),
                  _c("cargo-rich-textarea", {
                    staticStyle: { height: "70px", "min-height": "70px" },
                    attrs: {
                      "show-count": true,
                      no: "mark",
                      disabled: _vm.readonly,
                      "text-chars": 0,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Marks"),
                          _vm.form.mark,
                          _vm.isUppercaseByConfig,
                          function(val) {
                            _vm.form.mark = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.mark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "mark", $$v)
                      },
                      expression: "form.mark"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtSalesOffice.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "txtSalesOffice" }, slot: "txtSalesOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtSalesOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtSalesOffice.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      value: _vm.txtSalesOffice,
                      no: "txtSalesOffice",
                      disabled: true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.sales.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "sales" }, slot: "sales" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.sales.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sales.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "sales",
                    attrs: {
                      no: "sales",
                      disbled:
                        !_vm.canChangeSalesOfJob ||
                        _vm.pm.isWithinCloseAccountDate,
                      "method-params": {
                        officeId: _vm.salesOfficeCheck
                          ? _vm.$store.getters.currentOfficeId
                          : "",
                        category: "role",
                        shape: "sales"
                      },
                      "default-value": _vm.form.sales || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.txtSalesChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSalesId.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSalesId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSalesId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "cargoSalesId",
                      "method-params": {
                        category: "role",
                        shape: "salesOfGoods"
                      },
                      "default-value": _vm.form.cargoSalesId || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.form.cargoSalesId = p.value
                        _vm.pm.cargoSalesChargeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesDepartment.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesDepartment" }, slot: "salesDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-new-select", {
                    attrs: {
                      no: "salesOffice",
                      disabled: !_vm.form.sales,
                      enables: true,
                      "sales-id": Number(_vm.form.sales),
                      "office-id": _vm.form.salesOffice,
                      "department-id": Number(_vm.form.salesDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.departmentChargeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opOffice.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opOffice" }, slot: "opOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    attrs: {
                      no: "opOffice",
                      disabled:
                        (!_vm.isRegionalCommission &&
                          _vm.pm.isEntrustOrder(true)) ||
                        _vm.opOfficeDisabled,
                      "is-regional-commission": _vm.isRegionalCommission,
                      "office-id": Number(_vm.form.opOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.opOffice = p.value
                        _vm.form.opDepartment = 0
                        _vm.opOfficeChargeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opDepartment.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "opDepartment",
                      disabled: _vm.pm.isWithinCloseAccountDate,
                      "office-id": Number(_vm.form.opOffice),
                      enables: true,
                      "department-id": Number(_vm.form.opDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.opDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.op.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "op" }, slot: "op" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.op.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.op.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "op",
                      disabled: !_vm.opEabled,
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "op"
                      },
                      "default-value": _vm.form.op || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.txtOPChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrOffice.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    attrs: {
                      no: "csrOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.csrOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.csrOffice = p.value
                        _vm.form.csrDepartment = 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrDepartment.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "csrDepartment",
                      "office-id": Number(_vm.form.csrOffice),
                      enables: true,
                      "department-id": Number(_vm.form.csrDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.csrDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csr.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csr" }, slot: "csr" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csr.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.csr.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "csr",
                      "method-params": {
                        officeId:
                          _vm.pm.isEntrustOrder || _vm.fom.salesOffice === 1
                            ? _vm.form.opOffice
                            : _vm.form.salesOffice,
                        category: "role",
                        shape: "csr"
                      },
                      "default-value": _vm.form.csr || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.csrChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.siteOP.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "siteOP" }, slot: "siteOP" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.siteOP.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "siteOp"
                      },
                      "default-value": _vm.form.siteOP || ""
                    },
                    on: {
                      change: function(p) {
                        _vm.JobUtils.siteOpChangeHandler(_vm.form, p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.overseaOp.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "overseaOp" }, slot: "overseaOp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.overseaOp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "overseaOp",
                      "method-params": { category: "role", shape: "overseaOp" },
                      "default-value": _vm.form.overseaOp || "",
                      "static-options": _vm.isHC ? null : _vm.overseaOpList,
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.overseaOpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcOffice.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    attrs: {
                      no: "dcOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.dcOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.dcOffice = p.value
                        _vm.form.dcDepartment = 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcDepartment.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "dcDepartment",
                      "office-id": Number(_vm.form.dcOffice),
                      enables: true,
                      "department-id": Number(_vm.form.dcDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.dcDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dc.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dc" }, slot: "dc" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dc.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.dc.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "dc",
                      "method-params": {
                        officeId: _vm.form.opOffice,
                        category: "role",
                        shape: "doc"
                      },
                      "default-value": _vm.form.dc || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.dcChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerOffice &&
          _vm.elementDict.plannerOffice.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-office-select", {
                    attrs: {
                      no: "plannerOffice",
                      disabled: true,
                      "office-id": Number(_vm.form.plannerOffice)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.plannerOffice = p.value
                        _vm.form.plannerDepartment = 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerDepartment &&
          _vm.elementDict.plannerDepartment.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "plannerDepartment" },
                  slot: "plannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "plannerDepartment",
                      "office-id": Number(_vm.form.plannerOffice),
                      enables: true,
                      "department-id": Number(_vm.form.plannerDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.form.plannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.planner.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "planner" }, slot: "planner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.planner.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.planner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "planner",
                      "method-params": {
                        category: "role",
                        shape: "railwayLine"
                      },
                      "default-value": _vm.form.planner || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.txtPlannerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isAddUserDefinedRoles &&
                    _vm.elementDict.userDefinedRoleId1.masterVisible,
                  expression:
                    "isAddUserDefinedRoles && elementDict.userDefinedRoleId1.masterVisible"
                }
              ],
              attrs: { slot: "userDefinedRoleId1" },
              slot: "userDefinedRoleId1"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.userDefinedRoleId1.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.userDefinedRoleId1.label
                },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "userDefinedRoleId1",
                attrs: {
                  no: "userDefinedRoleId1",
                  "method-params": {
                    officeId: _vm.$store.getters.currentOfficeId,
                    category: "role",
                    shape: "userDefinedRole1"
                  },
                  "default-value": _vm.form.userDefinedRoleId1 || "",
                  "merge-load": true
                },
                on: {
                  change: function(p) {
                    _vm.pm.userDefinedRoleId1Handler(p)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isAddUserDefinedRoles &&
                    _vm.elementDict.userDefinedRoleId2.masterVisible,
                  expression:
                    "isAddUserDefinedRoles && elementDict.userDefinedRoleId2.masterVisible"
                }
              ],
              attrs: { slot: "userDefinedRoleId2" },
              slot: "userDefinedRoleId2"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.userDefinedRoleId2.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.userDefinedRoleId2.label
                },
                slot: "label"
              }),
              _c("cargo-user-select", {
                ref: "userDefinedRoleId2",
                attrs: {
                  no: "userDefinedRoleId2",
                  "method-params": {
                    officeId: _vm.$store.getters.currentOfficeId,
                    category: "role",
                    shape: "userDefinedRole2"
                  },
                  "default-value": _vm.form.userDefinedRoleId2 || "",
                  "merge-load": true
                },
                on: {
                  change: function(p) {
                    _vm.pm.userDefinedRoleId2Handler(p)
                  }
                }
              })
            ],
            1
          ),
          _vm.elementDict.userDefinedRoleId3 &&
          _vm.elementDict.userDefinedRoleId3.masterVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId3" },
                  slot: "userDefinedRoleId3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId3.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId3",
                    attrs: {
                      no: "userDefinedRoleId3",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole3"
                      },
                      "default-value": _vm.form.userDefinedRoleId3 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId3Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId4 &&
          _vm.elementDict.userDefinedRoleId4.masterVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId4" },
                  slot: "userDefinedRoleId4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId4.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId4",
                    attrs: {
                      no: "userDefinedRoleId4",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole4"
                      },
                      "default-value": _vm.form.userDefinedRoleId4 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId4Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId5 &&
          _vm.elementDict.userDefinedRoleId5.masterVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId5" },
                  slot: "userDefinedRoleId5"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId5.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId5.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId5",
                    attrs: {
                      no: "userDefinedRoleId5",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole5"
                      },
                      "default-value": _vm.form.userDefinedRoleId5 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId5Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId6 &&
          _vm.elementDict.userDefinedRoleId6.masterVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId6" },
                  slot: "userDefinedRoleId6"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId6.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId6.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId6",
                    attrs: {
                      no: "userDefinedRoleId6",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole6"
                      },
                      "default-value": _vm.form.userDefinedRoleId6 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId6Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId7 &&
          _vm.elementDict.userDefinedRoleId7.masterVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId7" },
                  slot: "userDefinedRoleId7"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId7.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId7.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId7",
                    attrs: {
                      no: "userDefinedRoleId7",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole7"
                      },
                      "default-value": _vm.form.userDefinedRoleId7 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.pm.userDefinedRoleId7Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId8 &&
          _vm.elementDict.userDefinedRoleId8.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId8" },
                  slot: "userDefinedRoleId8"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId8.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId8.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId8",
                    attrs: {
                      no: "userDefinedRoleId8",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole8"
                      },
                      "default-multiple-value": _vm.toNumArray(
                        _vm.form.userDefinedRoleId8
                      ),
                      multiple: true,
                      "merge-load": true,
                      placeholder: _vm.readonly ? " " : ""
                    },
                    on: {
                      change: function(p) {
                        _vm.form.userDefinedRoleId8 = _vm.toTxt(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtWhs.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "txtWhs" }, slot: "txtWhs" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtWhs.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtWhs.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "txtWhs",
                      disabled: true,
                      type: "textarea",
                      rows: 4,
                      value: _vm.txtWhs
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.remarks.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "remarks" }, slot: "remarks" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.remarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "remarks", type: "textarea", rows: 4 },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.remarks.label,
                          _vm.form.remarks,
                          false,
                          function(val) {
                            _vm.form.remarks = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField1.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField1" },
                  slot: "userDefinedField1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField1.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "userDefinedField1",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField1.label,
                          _vm.form.userDefinedField1,
                          false,
                          function(val) {
                            _vm.form.userDefinedField1 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField1,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField1", $$v)
                      },
                      expression: "form.userDefinedField1"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField2.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField2" },
                  slot: "userDefinedField2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField2.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "userDefinedField2",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField2.label,
                          _vm.form.userDefinedField2,
                          false,
                          function(val) {
                            _vm.form.userDefinedField2 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField2,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField2", $$v)
                      },
                      expression: "form.userDefinedField2"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField3.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField3" },
                  slot: "userDefinedField3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField3.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "userDefinedField3",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField3.label,
                          _vm.form.userDefinedField3,
                          false,
                          function(val) {
                            _vm.form.userDefinedField3 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField3,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField3", $$v)
                      },
                      expression: "form.userDefinedField3"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField4.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField4" },
                  slot: "userDefinedField4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField4.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "userDefinedField4",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField4.label,
                          _vm.form.userDefinedField4,
                          false,
                          function(val) {
                            _vm.form.userDefinedField4 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.form.userDefinedField4,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userDefinedField4", $$v)
                      },
                      expression: "form.userDefinedField4"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.exportControlledProduct &&
          _vm.elementDict.exportControlledProduct.masterVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "exportControlledProduct" },
                  slot: "exportControlledProduct"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.exportControlledProduct.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.exportControlledProduct.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "exportControlledProduct",
                        disabled: _vm.readonly,
                        placeholder: "",
                        clearable: true,
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.exportControlledProduct,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "exportControlledProduct", $$v)
                        },
                        expression: "form.exportControlledProduct"
                      }
                    },
                    _vm._l(_vm.EXPORT_CONTROLLED_PRODUCT, function(
                      item,
                      index
                    ) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    no: "taxNature",
                    placeholder: _vm.$t("SeaExport.PleaseSelect"),
                    size: "mini"
                  },
                  model: {
                    value: _vm.form.taxNature,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "taxNature", $$v)
                    },
                    expression: "form.taxNature"
                  }
                },
                _vm._l(_vm.TAX_NATURES, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: _vm.isZh ? item.chineseName : item.englishName,
                      value: item.code
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.elementDict.rateType && _vm.elementDict.rateType.masterVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "rateType" }, slot: "rateType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.rateType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "rateType",
                        clearable: "",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.form.rateType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "rateType", $$v)
                        },
                        expression: "form.rateType"
                      }
                    },
                    _vm._l(_vm.rateType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "form-card-wrapper",
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                width: "100%"
              },
              attrs: { slot: "ticketsInfo" },
              slot: "ticketsInfo"
            },
            [
              _c(
                "div",
                {
                  staticClass: "section form-column",
                  staticStyle: { flex: "1" }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.TicketsInfo")))
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-start",
                        "margin-bottom": "5px",
                        "line-height": "28px"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                      ]),
                      _c("span", { staticStyle: { "margin-right": "5px" } }, [
                        _vm._v(_vm._s(_vm.lclSlaves.length))
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.readonly &&
                                _vm.viewSource === "bookingWorkspace",
                              expression:
                                "readonly&&viewSource==='bookingWorkspace'"
                            }
                          ],
                          staticClass: "triggers"
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "NewTickets",
                                disabled:
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "primary"
                              },
                              on: { click: _vm.btnCreateClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.NewTickets")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "EditTickets",
                                disabled:
                                  !_vm.selectedRow ||
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "primary"
                              },
                              on: { click: _vm.btnLcLEditClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.EditTickets")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "AddTickets",
                                disabled:
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "primary"
                              },
                              on: { click: _vm.btnImportLclClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "RemoveTickets",
                                disabled:
                                  !_vm.selectedRow ||
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.btnBatchRemoveClickHandler()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: ["button_REBooking_deleteSmallTicket"],
                                  expression:
                                    "['button_REBooking_deleteSmallTicket']"
                                }
                              ],
                              attrs: {
                                no: "DeleteTickets",
                                disabled:
                                  !_vm.selectedRow ||
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "danger"
                              },
                              on: { click: _vm.btnRemoveClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteTickets")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "min-height": "200px",
                        "flex-direction": "column"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "300px" },
                        attrs: {
                          "config-module": "170003",
                          "grid-options": _vm.gridOptions,
                          "column-defs": _vm.columnDefs,
                          "row-data": _vm.lclSlaves
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceText",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "warning-count": -1,
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "ticket",
            visible: _vm.ticketDialog.visible,
            title: _vm.$t("SeaExport.FillInQuantityOfVotes"),
            width: "270px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.ticketDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "50px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Number") + "：" } },
                [
                  _c("el-input-number", {
                    attrs: { precision: 0, min: 1, max: 50, controls: false },
                    model: {
                      value: _vm.ticketDialog.value,
                      callback: function($$v) {
                        _vm.$set(_vm.ticketDialog, "value", $$v)
                      },
                      expression: "ticketDialog.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.toAddTicket }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.ticketDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("query-re-lcl-dialog", {
        attrs: { visible: _vm.queryRELclDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryRELclDialog, "visible", $event)
          },
          callback: function(rows) {
            _vm.pm.slavedAddedHandler(rows)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }